class CustomVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.variantData = this.getVariantData();
    this.addEventListener('click', this.onOptionClick.bind(this));
    this.updateOptions();
    this.updateMasterId();
  }

  onOptionClick(event) {
    const option = event.target.closest('button');
    if (!option) return;
    
    const position = parseInt(option.dataset.optionPosition) - 1;
    const value = option.dataset.value;
    
    // Update selected option
    const selectedOptions = this.querySelectorAll(`.custom-variant-picker__option.is-selected`);
    selectedOptions[position].classList.remove('is-selected');
    option.classList.add('is-selected');
    this.querySelectorAll('.custom-variant-picker__option').forEach(button => {
      button.setAttribute('aria-checked', String(button.classList.contains('is-selected')));
    });

    // Update options array
    this.options[position] = value;
    
    this.updateMasterId();
    this.updatePickerState();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = [];
    this.querySelectorAll('.custom-variant-picker__option.is-selected').forEach((option) => {
      this.options.push(option.dataset.value);
    });
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updatePickerState() {
    // Get all variant options
    const optionButtons = this.querySelectorAll('.custom-variant-picker__option');
    
    optionButtons.forEach(button => {
      const position = parseInt(button.dataset.optionPosition) - 1;
      const value = button.dataset.value;
      
      // Create a copy of current options
      const tempOptions = [...this.options];
      tempOptions[position] = value;
      
      // Check if this combination exists and is available
      const matchingVariant = this.variantData.find(variant => 
        variant.options.every((option, index) => tempOptions[index] === option)
      );
      
      if (!matchingVariant || !matchingVariant.available) {
        button.classList.add('is-sold-out');
        button.disabled = true;
      } else {
        button.classList.remove('is-sold-out');
        button.disabled = false;
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || !this.dataset.url) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const input = this.querySelector('[data-variant-input]');
    if (!input) return;

    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Also update the in-form hidden input that product-form.js reads via FormData.
    // buy-buttons.liquid renders its own <input name="id" class="product-variant-id">
    // inside the <form> element. Without this update that input stays at the initial
    // variant and always wins when FormData is serialised, causing the wrong variant
    // (e.g. the first $50 denomination) to be added to cart regardless of selection.
    const formId = input.getAttribute('form');
    if (formId) {
      const form = document.getElementById(formId);
      if (form) {
        const formInput = form.querySelector('input[name="id"]');
        if (formInput) {
          formInput.value = this.currentVariant.id;
          formInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  renderProductInfo() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const price = html.getElementById(`price-${this.dataset.section}`);
        const inventory = html.getElementById(`inventory-${this.dataset.section}`);
        const sku = html.getElementById(`sku-${this.dataset.section}`);
        
        if (price) document.getElementById(`price-${this.dataset.section}`).innerHTML = price.innerHTML;
        if (inventory) document.getElementById(`inventory-${this.dataset.section}`).innerHTML = inventory.innerHTML;
        if (sku) document.getElementById(`sku-${this.dataset.section}`).innerHTML = sku.innerHTML;
      });
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    
    if (button) {
      button.disabled = true;
      button.querySelector('span').textContent = window.variantStrings?.unavailable || 'Unavailable';
    }
    
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    return JSON.parse(this.querySelector('[data-variants]').textContent);
  }
}

customElements.define('custom-variant-picker', CustomVariantPicker);
